import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MEASUREMENT_MODE } from '../../../../app.constants';
import {
  MeasurementEntry,
  MeasurementResult,
  MeasurementUnit
} from "../../../../_services/inspection/measurement-result.factory";

@Component({
    selector: 'app-measurement-results',
    templateUrl: './measurement-results.component.html',
    styleUrl: './measurement-results.component.scss',
    standalone: false
})
export class MeasurementResultsComponent {
  readonly units = [MeasurementUnit.MM, MeasurementUnit.Inch];
  readonly unitLetter = this.translate.instant('imageRemeasurementEdit.changeUnit');
  readonly inchScale = 25.4; // 1in = 25.4mm
  readonly SquareInchScale = Math.pow(this.inchScale, 2);
  readonly Modes = MEASUREMENT_MODE;

  @Input() public selectResult: MeasurementResult | null;
  @Input() public selectedMeasurementSystem: string;
  @Input() public isAddPoints = false;
  @Input() public isEdit = false;
  @Input() public measurementResults: MeasurementResult[] = [];

  @Output() public removeObject = new EventEmitter<MeasurementResult>();
  @Output() public changeUnit = new EventEmitter<void>();

  constructor(private translate: TranslateService) {}

  getMeasurementResultSelectLabel(result: MeasurementResult): string {
    const id = result.id.split(':')[0];
    return  id + ' : ' + this.translate.instant(`imageRemeasurementEdit.${result.mode}`);
  }

  deleteResult(result: MeasurementResult) {
    this.removeObject.emit(result);
  }

  getChangeUnitLabel(): string {
    const unit = this.selectedMeasurementSystem === MeasurementUnit[this.units[0]].toLowerCase() ? this.units[1] : this.units[0];
    return this.unitLetter + ' ' + MeasurementUnit[unit].toLowerCase();
  }

  getUnitLabel(unit: MeasurementUnit): string {
    if (this.selectedMeasurementSystem === 'mm') {
      switch (unit) {
        case MeasurementUnit.MM:
        case MeasurementUnit.Inch:
          return "mm";
        case MeasurementUnit.MM_Squared:
        case MeasurementUnit.Inch_Squared:
          return "mm²";
        case MeasurementUnit.Degree:
          return "°";
      }

    } else {
      switch (unit) {
        case MeasurementUnit.MM:
        case MeasurementUnit.Inch:
          return "inch";
        case MeasurementUnit.MM_Squared:
        case MeasurementUnit.Inch_Squared:
          return "inch²";
        case MeasurementUnit.Degree:
          return "°";
      }
    }
  }

  convertToSelectedUnit(value: number, isArea: boolean = false) {
    if (this.selectedMeasurementSystem === MeasurementUnit[this.units[1]].toLowerCase()) {
      return isArea ? value / this.SquareInchScale : value / this.inchScale;
    }
    return value;
  }

  getFormattedValue(entry: MeasurementEntry): string {
    if (!entry.value) {
      return '-';
    }

    if (this.selectedMeasurementSystem === "mm") {
      switch (entry.unit) {
        case MeasurementUnit.MM:
        case MeasurementUnit.MM_Squared:
          return entry.value.toFixed(2);
        case MeasurementUnit.Degree:
          return entry.value.toFixed(2);
      }
    } else {
      switch (entry.unit) {
        case MeasurementUnit.MM:
          return this.convertToSelectedUnit(entry.value).toFixed(3);
        case MeasurementUnit.MM_Squared:
          return this.convertToSelectedUnit(entry.value, true).toFixed(3);
        case MeasurementUnit.Degree:
          return entry.value.toFixed(2);
      }
    }
  }
}
